var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAthleteTrophy = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 50 50",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15 19.9998H12.5C11.3949 19.9998 10.3351 19.5609 9.55372 18.7794C8.77232 17.998 8.33333 16.9382 8.33333 15.8332C8.33333 14.7281 8.77232 13.6683 9.55372 12.8869C10.3351 12.1055 11.3949 11.6665 12.5 11.6665H15",
  strokeWidth: 2.66667,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M35 19.9998H37.5C38.6051 19.9998 39.6649 19.5609 40.4463 18.7794C41.2277 17.998 41.6667 16.9382 41.6667 15.8332C41.6667 14.7281 41.2277 13.6683 40.4463 12.8869C39.6649 12.1055 38.6051 11.6665 37.5 11.6665H35",
  strokeWidth: 2.66667,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6667 41.6665H38.3333",
  strokeWidth: 2.66667,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: "currentColor"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6667 29.4331V33.3331C21.6667 34.2498 20.8833 34.9664 20.05 35.3498C18.0833 36.2498 16.6667 38.7331 16.6667 41.6664",
  strokeWidth: 2.66667,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: "currentColor"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3333 29.4331V33.3331C28.3333 34.2498 29.1167 34.9664 29.95 35.3498C31.9167 36.2498 33.3333 38.7331 33.3333 41.6664",
  strokeWidth: 2.66667,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: "currentColor"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M35 8.3335H15V20.0002C15 22.6523 16.0536 25.1959 17.9289 27.0712C19.8043 28.9466 22.3478 30.0002 25 30.0002C27.6522 30.0002 30.1957 28.9466 32.0711 27.0712C33.9464 25.1959 35 22.6523 35 20.0002V8.3335Z",
  strokeWidth: 2.66667,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: "currentColor"
})));
export default SvgAthleteTrophy;